import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import styles from './Sidebar.module.css';
import logo from '../assets/sagarlogo.jpg';

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isAdmin        = user?.role === 'ADMIN';
  const isReceptionist = user?.role === 'RECEPTIONIST';
  const isDoctor       = user?.role === 'DOCTOR';

  const displayRole = user?.role === 'RECEPTIONIST' ? 'FRONT OFFICE' : user?.role;

  const navItems = [
    { to: '/dashboard',    label: '📊 Dashboard',       show: true },
    { to: '/branches',     label: '🏢 Branches',         show: isAdmin },
    { to: '/departments',  label: '🏬 Departments',      show: isAdmin },
    { to: '/doctors',      label: '👨‍⚕️ Doctors',         show: isAdmin },
    { to: '/slots',        label: '🕐 Slots',            show: isAdmin || isReceptionist },
    { to: '/book-appointment', label: '📝 Book Appointment', show: isAdmin || isReceptionist },
    { to: '/appointments', label: '📋 Appointments',     show: true },
    { to: '/patients',     label: '🧑‍⚕️ Patients',        show: true },
    { to: '/users',        label: '👥 User Management',  show: isAdmin },
  ];

  const roleColor = {
    ADMIN: '#c0272d',
    RECEPTIONIST: '#1565c0',
    DOCTOR: '#2e7d32',
  };

  return (
    <div className={styles.sidebar}>
      <div className={styles.logoArea}>
        <img src={logo} alt="Sagar Hospitals" className={styles.logo} />
      </div>

      {/* User info */}
      <div style={{
        padding: '10px 16px 14px',
        borderBottom: '1px solid #e8edf6',
        marginBottom: 8,
      }}>
        <p style={{ margin: 0, fontWeight: 700, color: '#1a3a6b', fontSize: 14 }}>
          {user?.username}
        </p>
        <span style={{
          fontSize: 11, fontWeight: 700, padding: '2px 8px',
          borderRadius: 10, marginTop: 4, display: 'inline-block',
          background: (roleColor[user?.role] || '#888') + '18',
          color: roleColor[user?.role] || '#888',
        }}>
          {displayRole}
        </span>
      </div>

      <nav className={styles.nav}>
        {navItems.filter(i => i.show).map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `${styles.navItem} ${isActive ? styles.active : ''}`
            }>
            {item.label}
          </NavLink>
        ))}
      </nav>

      <button onClick={handleLogout} style={{
        margin: '16px', width: 'calc(100% - 32px)',
        background: '#fff0f0', color: '#c0272d',
        border: '1.5px solid #c0272d', borderRadius: 8,
        padding: '9px', fontSize: 13, fontWeight: 700,
        cursor: 'pointer',
      }}>
        🚪 Logout
      </button>
    </div>
  );
}
